const formatPhoneNumber = (phoneNumber: string) => phoneNumber.startsWith('06') ? phoneNumber : `06${phoneNumber}`

export default formatPhoneNumber
